import React from 'react';
import { InfoIcon, SmartphoneIcon, XIcon } from 'lucide-react';
import { StatusBar } from '../phone/StatusBar';
export function PlayScreen() {
  return <div className="flex h-full flex-col bg-canvas" data-id="element-378" data-mp="2j7oq5055gd3s">
      <StatusBar data-id="element-379" data-mp="2edtz1bn7svuo" />
      <div className="flex items-center gap-3 px-4 pt-5" data-id="element-380" data-mp="2edc6aozrgzri">
        <span className="grid h-8 w-8 place-items-center rounded-full bg-white ring-1 ring-line" data-id="element-381" data-mp="2adtmjwjoeuq9">
          <XIcon className="h-3.5 w-3.5" data-id="element-382" data-mp="25eqf65g84cf4" />
        </span>
        <div className="flex flex-1 gap-1" data-id="element-383" data-mp="25fi9lcy3443t">
          {[0, 1, 2].map(i => <span key={i} className={`h-1 flex-1 rounded-full ${i === 0 ? 'bg-forest' : 'bg-line'}`} data-id="element-384" data-mp="20dj7s7hztf8z" />)}
        </div>
      </div>

      <div className="flex-1 px-5 pt-7" data-id="element-385" data-mp="1refob2ewyxty">
        <div className="flex items-center gap-2" data-id="element-386" data-mp="1rfhao31dr6qz">
          <span className="leaf-sm grid h-7 w-7 place-items-center bg-ink text-white" data-id="element-387" data-mp="1rgsfm66kakjo">
            <SmartphoneIcon className="h-3.5 w-3.5" data-id="element-388" data-mp="3pry1z7bs5ubv" />
          </span>
          <p className="text-[10px] font-semibold text-muted" data-id="element-389" data-mp="3ltrzwclw02xa">Electronics brand · Question 1 of 3</p>
        </div>
        <p className="mt-4 font-display text-[20px] font-extrabold leading-[1.15] tracking-tight" data-id="element-390" data-mp="3jyeuz0snnftv">
          How important is a lighter weight in your next phone?
        </p>
        <div className="mt-4 flex gap-2 rounded-2xl bg-mint-soft p-3" data-id="element-391" data-mp="3b035j23iyo30">
          <InfoIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-forest" data-id="element-392" data-mp="3f03lir69v7c6" />
          <p className="text-[10px] leading-snug text-forest-deep" data-id="element-393" data-mp="3f2gb9qi9ulzs">
            <span className="font-bold" data-id="element-394" data-mp="6ld6fe6w3gpa">Why we ask:</span> the brand wants to know what matters to visitors. Shared
            only as group totals.
          </p>
        </div>
        <div className="mt-6 grid grid-cols-5 gap-1.5" data-id="element-395" data-mp="3twuotbj2h372">
          {[1, 2, 3, 4, 5].map(n => <span key={n} className={`grid h-11 place-items-center rounded-xl text-[13px] font-bold ${n === 4 ? 'bg-forest text-white' : 'bg-white ring-1 ring-line'}`} data-id="element-396" data-mp="1t1vzheiwcih">
              {n}
            </span>)}
        </div>
        <div className="mt-2 flex justify-between text-[9px] text-muted" data-id="element-397" data-mp="145d3mw74kf90">
          <span data-id="element-398" data-mp="1049oyd0tcp9d">Not important</span>
          <span data-id="element-399" data-mp="105azmgdx39qk">Very important</span>
        </div>
      </div>

      <div className="px-5 pb-7" data-id="element-400" data-mp="v56shgywfrd0">
        <span className="flex h-11 items-center justify-center rounded-full bg-forest text-[12px] font-bold text-white" data-id="element-401" data-mp="v4f0eg4igbrh">
          Next
        </span>
        <p className="mt-2 text-center text-[9px] text-muted" data-id="element-402" data-mp="l7a8dznzhm2r">Prize: a smartphone · Rules shown before you start</p>
      </div>
    </div>;
}